import { Navigate, Outlet } from "react-router-dom";
import { MoonLoader } from "react-spinners";

import { useProfile } from "@/hooks/server-state/use-profile";
import { useSession } from "@/hooks/server-state/use-session";

const AuthMiddleware = () => {
  const { data: sessionData, isLoading: isSessionLoading } = useSession();
  const { data: profileData, isLoading: isProfileLoading } = useProfile();

  const isLoading = isSessionLoading && isProfileLoading;

  if (isLoading) return <Loading />;

  if (sessionData?.needNewPassword)
    return (
      <Navigate to="/dashboard/change-password?requireOldPassword=false" />
    );

  if (
    profileData &&
    (profileData?.scopusID == null ||
      profileData?.webOfScienceID == null ||
      profileData?.googleScholarID == null) &&
    sessionData &&
    !location.pathname.includes("update-user-info")
  ) {
    return <Navigate to="/dashboard/update-user-info" />;
  }

  return sessionData ? <Outlet /> : <Navigate to="/dashboard/login" />;
};

const Loading = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      <MoonLoader color="#0099A5" size={50} />
    </div>
  );
};

export default AuthMiddleware;
